import _ from 'lodash';
import store from 'store2';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { normalizeCMSData } from '../../resources/shoppingLinks/shoppingHelper.constant';
import normalizeShoppingLinksData from '../../resources/shoppingLinks/normalizeShoppingLinks';
import {
  CMS_SCRIPT_LOADED,
  SHOPPING_LINKS_LOADED,
  INIT_ROOT
} from '../actionTypes';

import {
  getQueryStringValue,
  removeQueryStringFromUrl,
  hasQueryStringParam
} from '../../common/routing/queryStringHelpers';
import { getByModelAndKey } from '../../resources/localStorage/localStorage.service';
import { getVisitedTabs } from '../../factories/progressTracker/progressTracker';
import { getPostalCode } from '../../factories/initializePostalCode/initializePostalCode.factory';
import { initialize as initializeAnalytics } from '../../factories/analytics/analytics.service';
import getDeviceType from '../../common/getDeviceType';

const AUTH_TOKEN_KEY = 'byo.auth';

export const cmsScriptLoaded = data => {
  return (dispatch, getState) => {
    dispatch({
      type: CMS_SCRIPT_LOADED,
      payload: normalizeCMSData(data, getState())
    });
  };
};

export const shoppingLinksLoaded = data => {
  return (dispatch, getState) => {
    dispatch({
      type: SHOPPING_LINKS_LOADED,
      payload: normalizeShoppingLinksData(data, getState())
    });
  };
};

export const initRoot = () => {
  const appResources = window.appResources;
  const uiPath = window.UI_PATH;
  const contextPath = window.CONTEXT_PATH;
  const version = window.VERSION;
  const authEnabled = window.AUTH_CONTEXT.enabled;
  const authRedirectUrl = window.AUTH_CONTEXT.redirectUrl;

  const {
    brand,
    country,
    bodyStyle,
    carline,
    language,
    year,
    region,
    urls
  } = appResources;

  const location = window.location;

  const postalCode = getPostalCode(
    country,
    brand,
    getQueryStringValue(location.search, 'postalCode'),
    urls.zipCodeUrl
  );

  if (hasQueryStringParam(location.search, 'postalCode')) {
    const urlWithPostalCodeRemoved = removeQueryStringFromUrl(
      location,
      'postalCode'
    );

    history.replaceState(
      { path: urlWithPostalCodeRemoved },
      null,
      urlWithPostalCodeRemoved
    );
  }

  const params = {
    bodystyle: bodyStyle,
    brand: brand,
    carline,
    country: country,
    lang: language,
    modelyear: year,
    region,
    postalCode: _.get(postalCode, 'value')
  };

  const localConfig = getByModelAndKey(appResources, 'config');

  initializeAnalytics(postalCode);

  return {
    type: INIT_ROOT,
    payload: {
      appResources,
      params,
      visited: getVisitedTabs(),
      wasOptionToggled: _.get(localConfig, 'toggled', false),
      wasTrimOptionToggled: _.get(localConfig, 'toggledTrim', false),
      isDefaultPostalCode: _.get(postalCode, 'isDefault'),
      deviceType: getDeviceType(),
      uiPath,
      contextPath,
      version,
      breakpoint: MediaQuery.current,
      authEnabled,
      authRedirectUrl,
      token: store.get(AUTH_TOKEN_KEY)
    }
  };
};
